import { ServicePartnerModel, ServicePartnerModelObject } from './servicePartnersModel';

export interface ServicePartnerPaymentHistoryModel {
  id: number;
  date: string;
  spPaymentMethod: number;
  spBankAccountId: number;
  amount: number;
  paidById: number;
  paidByName: string;
  receivedById: number;
  receivedByName: string;
  voucherNumber: string;
  note: string;
  servicePartnerId: number;
   serviceOrderId: number;
}

export const ServicePartnerPaymentHistoryModelData: ServicePartnerPaymentHistoryModel = {
  id: 0,
  date: '',
  spPaymentMethod: 0,
  spBankAccountId: 0,
  amount: 0,
  paidById: 0,
  paidByName: '',
  receivedById: 0,
  receivedByName: '',
  voucherNumber: '',
  note: '',
  servicePartnerId: 0,
   serviceOrderId: 0
};
